import { Link } from "react-router-dom";
import { ShoppingBag, CalendarCheck, Instagram, Music2 } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../../context/CartContext";

export const MobileActionBar = () => {
    const { count, setCartOpen } = useCart();

    return (
        <nav
            data-testid="mobile-action-bar"
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-ink/95 backdrop-blur-xl border-t border-zinc-800 grid grid-cols-3"
        >
            <Link
                to="/shop"
                data-testid="mobile-bar-shop"
                className="flex flex-col items-center gap-1 py-3 text-white active:bg-white/5"
            >
                <ShoppingBag size={18} />
                <span className="font-oswald text-[11px] tracking-[0.25em] uppercase">Shop</span>
            </Link>
            <Link
                to="/book"
                data-testid="mobile-bar-book"
                className="flex flex-col items-center gap-1 py-3 bg-pink text-ink active:bg-pink-dark"
            >
                <CalendarCheck size={18} />
                <span className="font-oswald text-[11px] tracking-[0.25em] uppercase font-semibold">Book</span>
            </Link>
            <button
                onClick={() => setCartOpen(true)}
                data-testid="mobile-bar-cart"
                className="relative flex flex-col items-center gap-1 py-3 text-white active:bg-white/5"
            >
                <span className="relative">
                    <ShoppingBag size={18} />
                    {count > 0 && (
                        <span className="absolute -top-2 -right-2.5 h-4 min-w-4 px-0.5 rounded-full bg-pink text-ink text-[9px] font-extrabold flex items-center justify-center">
                            {count}
                        </span>
                    )}
                </span>
                <span className="font-oswald text-[11px] tracking-[0.25em] uppercase">Cart</span>
            </button>
        </nav>
    );
};
